import type { Sx } from '@/shared/types/uiTypes';

type SxItem = Exclude<Sx, ReadonlyArray<unknown>>;

export const normalizeSx = (sx?: Sx): SxItem[] => {
  if (Array.isArray(sx)) return sx as SxItem[];
  if (sx) return [sx as SxItem];
  return [];
};
